export default {
  baseFontSize: '16px',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  lineHeight: '1.5',
  borderRadius: '3px',
  innerBorderRadius: '2px',
  textColor: '#000',
  whiteColor: '#fff',
  lightColor: '#efefef',
  borderColor: '#ddd',
  buttonColor: '#e0e1e2',
  sideNavColor: '#212121',
  sideNavBorderColor: '#444',
  hintColor: 'rgba(0,0,0,.6)',
  primaryColor: 'rgb(0, 102, 221)',
  successColor: 'rgb(0, 187, 102)',
  dangerColor: 'rgb(221, 0, 0)',
  hintLightColor: 'rgb(239, 239, 239)',
  primaryLightColor: 'rgb(198, 224, 255)',
  successLightColor: 'rgb(175, 255, 212)',
  dangerLightColor: 'rgb(255, 211, 211)',
};
